module.exports = __webpack_public_path__ + "img/kd.ed5c31b8.png";